<div class="dashboard-panel">
  <div class="dashboard-col">
    <div class="dashboard-cell">
      <div class="carousel-container">
        <ignite-image-carousel [imageDefs]="imageDefs"></ignite-image-carousel>
      </div>
    </div>
    <div class="dashboard-cell">
      <mat-card ignite-dashboard-card class="info">
        <mat-card-content>
          <div style="display: flex">
            <div style="margin-right: 8px; font-size: 18px; color: #007fa3">
              <i class="fal fa-info-circle"></i>
            </div>
            <div>
              <div>
                Note: <b>You will be allowed to take a test if your myPTE account details exactly your government-issued ID.</b> In most
                cases, this will be your valid passport.
              </div>
              <div style="margin-top: 8px">To find out which IDs we accept, please check out <a>ID Policy</a>.</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="dashboard-col">
    <div class="dashboard-cell">
      <mat-card ignite-dashboard-card class="warning">
        <mat-card-header>
          <div mat-card-avatar class="incomplete-profile-image"></div>
          <mat-card-title>Your profile is incomplete</mat-card-title>
        </mat-card-header>
        <mat-card-content> Make sure you're ready for your test by completing the following steps. </mat-card-content>
        <mat-card-actions class="ignite-dialog-buttons-container">
          <button mat-button class="ignite-button" color="accent" [disabled]="true"><i class="fas fa-check"></i>Create account</button>
          <button mat-button class="ignite-button" color="accent">Verify email</button>
          <button mat-button class="ignite-button" color="accent">Learn more</button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="dashboard-cell">
      <mat-card ignite-dashboard-card>
        <mat-card-header>
          <div mat-card-avatar class="special-arrangements-image"></div>
          <mat-card-title>Special arrangements</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          Please launch and complete the form. Our support team will notify you if the request is accepted. You'll then need to contact
          our call centre to book the test.
        </mat-card-content>
        <mat-card-actions class="ignite-dialog-buttons-container">
          <button mat-button class="ignite-button" color="primary">Launch form</button>
          <button mat-button class="ignite-button" color="secondary">Learn more</button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="dashboard-cell">
      <mat-card ignite-dashboard-card important="true">
        <mat-card-header>
          <div mat-card-avatar class="waiting-for-results-image"></div>
          <mat-card-title>We're scoring your test</mat-card-title>
        </mat-card-header>
        <mat-card-content
          >We'll update you as soon as your score is available.
          <mat-progress-bar ignite-progress-bar color="contrast" mode="determinate" value="40"></mat-progress-bar>
        </mat-card-content>
        <mat-card-actions class="ignite-dialog-buttons-container">
          <button mat-button class="ignite-button" color="secondary">Learn more</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>